export default __webpack_public_path__ + "static/media/poa.dc905d28.svg";